{
  "ramps": {
    "puRed": ["#9A1024", "#E82A3C", "#FF8A8E"],
    "puYellow": ["#B87800", "#FFC81E", "#FFF08A"],
    "puBlue": ["#1A3C9E", "#2E74F0", "#94C0FF"],
    "puPurple": ["#5C1492", "#A838E6", "#DC9AFF"],
    "puGreen": ["#146A20", "#2EBE3C", "#9AF08A"],
    "puWhite": ["#9C9CB8", "#DEDEEE", "#FFFFFF"],
    "puHeart": ["#A0103C", "#FF2E66", "#FF9CBC"],
    "puGold": ["#8C5A0A", "#E8A81C", "#FFE482"],
    "puOrange": ["#B04A08", "#FF8A1E", "#FFC878"],
    "puWood": ["#5C3418", "#9C5E2C", "#D69A5E"],
    "puCyan": ["#0A6E96", "#1ECCF0", "#AAF4FF"],
    "puGlass": ["#6E90AE", "#C4E2F2", "#F2FBFF"],
    "puSteel": ["#181A2C", "#363C58", "#6E76A0"],
    "bossRobe": ["#004E08", "#009A12", "#2CCC2C", "#8EEE82"],
    "bossFace": ["#B47C56", "#F2BE92", "#FFE2C8"],
    "bossNose": ["#A82A4C", "#F0607E", "#FFAEC0"],
    "bossBrow": ["#1E120C", "#4A2E1E", "#7A5238"],
    "bossFeet": ["#8A0044", "#E0146E", "#FF72B2"],
    "bossRope": ["#9A6A10", "#E6B83A", "#FFE68C"]
  }
}
